import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UnknownRequestComponent } from 'src/components/unknown-request/unknown-request.component';
import { UsertableComponent } from 'src/components/usertable/usertable.component';
import { AuthenticationGuard } from 'microsoft-adal-angular6';

// Routes

const appRoutes: Routes = [
  { path: 'unknownrequest', component: UnknownRequestComponent, pathMatch: 'full', canActivate: [AuthenticationGuard] },
  { path: 'conversation', component: UsertableComponent, pathMatch: 'full', canActivate: [AuthenticationGuard] },
  { path: '**', component: UsertableComponent, canActivate: [AuthenticationGuard] }
];


@NgModule({
  imports: [RouterModule.forRoot(appRoutes,
    { enableTracing: true } // <-- debugging purposes only
  ),],
  exports: [RouterModule]
})
export class AppRoutingModule { }
